import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
export var FrameGraphPass = function FrameGraphPass() {
  _classCallCheck(this, FrameGraphPass);

  this.name = void 0;
  this.data = void 0;
  this.execute = void 0;
  this.tearDown = void 0;
};
//# sourceMappingURL=FrameGraphPass.js.map